import { render, staticRenderFns } from "./AsociarFactura.vue?vue&type=template&id=b5724fde"
import script from "./AsociarFactura.vue?vue&type=script&lang=js"
export * from "./AsociarFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports